import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["button", "text", "spinner"];

  async translate({ params }) {
    // Show spinner and disable button
    this.buttonTarget.disabled = true;
    this.textTarget.classList.add("d-none");
    this.spinnerTarget.classList.remove("d-none");
    this.clearError();

    try {
      const url = new URL("/translate", document.location);
      url.searchParams.append(
        "text",
        document.getElementById(params.source).value,
      );

      const response = await fetch(url.href);
      if (response.ok) {
        const target = document.getElementById(params.target);
        response.text().then((text) => {
          target.value = text;
          target.dispatchEvent(new Event("input")); //trigger autogrow
        });
      } else {
        this.showError(await response.text());
      }
    } catch (error) {
      this.showError(error.message);
    } finally {
      // Hide spinner and re-enable button
      this.buttonTarget.disabled = false;
      this.textTarget.classList.remove("d-none");
      this.spinnerTarget.classList.add("d-none");
    }
  }

  showError(message) {
    const alert = document.createElement("div");
    alert.className = "alert alert-danger alert-dismissible fade show mt-2";
    alert.role = "alert";
    alert.dataset.translatorError = "";
    alert.textContent = message || "Translation failed. Try again.";

    const dismiss = document.createElement("button");
    dismiss.type = "button";
    dismiss.className = "btn-close";
    dismiss.dataset.bsDismiss = "alert";
    dismiss.ariaLabel = "Close";
    alert.appendChild(dismiss);

    this.element.insertAdjacentElement("afterend", alert);
  }

  clearError() {
    const existing = this.element.nextElementSibling;
    if (existing?.matches("[data-translator-error]")) existing.remove();
  }
}
